import React from "react";
import "./style.css";
import LabelSpan from "../LabelSpan";

export default function SelectInput({
  label,
  required,
  className,
  placeholder,
  value,
  onChange,
  disabled,
  options = [],
}) {
  const inputRequired = required ? (
    <span className="danger">&nbsp;*</span>
  ) : null;
  const inputLabel = label ? (
    <LabelSpan>
      {label}
      {inputRequired}
    </LabelSpan>
  ) : null;

  return (
    <label>
      {inputLabel}
      <select
        className={`${className}`}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}

        {options.map((opt) =>
          typeof opt === "object" ? (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ) : (
            <option key={opt} value={opt}>
              {opt}
            </option>
          )
        )}
      </select>
    </label>
  );
}
